import badge1 from "@images/badges/badge-1.png";
import badge2 from "@images/badges/badge-2.png";
import badge3 from "@images/badges/badge-3.png";
import badge4 from "@images/badges/badge-4.png";
import badge5 from "@images/badges/badge-5.png";
import badge6 from "@images/badges/badge-6.png";
import badge7 from "@images/badges/badge-7.png";
import badge8 from "@images/badges/badge-8.png";
import badge9 from "@images/badges/badge-9.png";
import badge10 from "@images/badges/badge-10.png";

export const SCENARIO_CERTIFICATION_BADGES = [
  {
    id: 0,
    image: badge1,
    name: "badge_1",
  },
  {
    id: 1,
    image: badge2,
    name: "badge_2",
  },
  {
    id: 2,
    image: badge3,
    name: "badge_3",
  },
  {
    id: 3,
    image: badge4,
    name: "badge_4",
  },
  {
    id: 4,
    image: badge5,
    name: "badge_5",
  },
  {
    id: 5,
    image: badge6,
    name: "badge_6",
  },
  {
    id: 6,
    image: badge7,
    name: "badge_7",
  },
  {
    id: 7,
    image: badge8,
    name: "badge_8",
  },
  {
    id: 8,
    image: badge9,
    name: "badge_9",
  },
  {
    id: 9,
    image: badge10,
    name: "badge_10",
  },
];

export const API_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
